document.addEventListener('DOMContentLoaded', ()=>{
    let btns = document.querySelectorAll('.product-information__link')
    btns.forEach(btn => {
        btn.addEventListener('click', ()=> {
            document.querySelector('body').classList.add('locked')
            document.getElementById('productInformationDrawer').classList.add('is-active')
            document.querySelector('.product-information-drawer__overlay').classList.add('is-active')
            let block_name = btn.getAttribute('data-id')
            document.querySelector(`#productInformationDrawer div[data-id="${block_name}"]`).scrollIntoView({block: "start", behavior: "smooth"})
        })
    })

    let close = document.querySelector('.product-information-drawer__close')
    close.addEventListener('click', ()=>{
        document.querySelector('body').classList.remove('locked')
        document.getElementById('productInformationDrawer').classList.remove('is-active')
        document.querySelector('.product-information-drawer__overlay').classList.remove('is-active')
    })

    document.querySelector('.product-information-drawer__overlay').addEventListener('click', ()=>{
        close.click();
    })
})